import React, { lazy } from 'react';

const CourseActivityWelcome = lazy(() => import('@/pages/client/CourseActivity/Welcome/index.js'));
const CourseActivityMilestone = lazy(() => import('@/pages/client/CourseActivity/Milestone/index.js'));
const CourseActivityHome = lazy(() => import('@/pages/client/CourseActivity/Home/index.js'));
const CourseActivityPayment = lazy(() => import('@/pages/client/CourseActivity/Payment/index.js'));
const Chat = lazy(() => import('@/pages/client/CourseActivity/Chat/index.js'));
const CourseActivityCertificate = lazy(() => import('@/pages/client/CourseActivity/Certificate/index.js'));
const QuickTestMilestone = lazy(() => import('@/pages/client/CourseActivity/QuickTestMilestone/index.js'));
const FormTestIntro = lazy(() => import('@/pages/client/CourseActivity/FormTestIntro/index.js'));

// 课程活动路由
const CourseActivityRoutes = [
    { path: '/client/course-activity/welcome', component: <CourseActivityWelcome />, needInterceptor: true },
    { path: '/client/course-activity/milestone/:pageId', component: <CourseActivityMilestone />, needInterceptor: true },
    { path: '/client/course-activity/chat', component: <Chat />, needInterceptor: true },
    { path: '/client/course-activity/quick-test', component: <QuickTestMilestone />, needInterceptor: true },
    { path: '/client/course-activity/quick-test/:courseActivityInstanceId', component: <QuickTestMilestone />, needInterceptor: true },
    // 首页
    {
        path: '/client/course-activity/home',
        component: <CourseActivityHome />,
        needInterceptor: true
    },
    // 付款页面
    {
        path: '/client/course-activity/payment',
        component: <CourseActivityPayment />,
        needInterceptor: true
    },
    { path: '/client/course-activity/certificate', component: <CourseActivityCertificate />, needInterceptor: true },
    { path: '/client/course-activity/form-test-intro', component: <FormTestIntro />, needInterceptor: true },
];

export default CourseActivityRoutes;
